/* ============
 * Add Batch Log Component
 * ============
 *
 * This is the component for creating batch log
 */
import { mapMutations } from 'vuex';

export default {

  props: {
    materials: {
      required: true,
      type: Array,
    },
    batchId: {
      required: true,
      type: Number,
    },
    message: {
      required: true,
      type: String,
    },
    /**
     * The buttons to display under the body of the embedded frame
     */
    buttons: {
      type: Array,
      required: false,
    },
  },

  created() {
  },

  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),


    adjustQty() {
      this.closeModal();
      this.$router.push({
        name: 'products.edit',
        params: {
          id: this.productId,
        },
      });
    },

    addNew() {
      this.closeModal();
      this.$router.push({
        name: 'products.edit',
        params: {
          id: this.productId,
        },
      });
    },

    purchaseOrder() {
      this.closeModal();
      this.$router.push({
        name: 'products.edit',
        params: {
          id: this.productId,
        },
      });
    },

    stockAdjustment() {
      this.closeModal();
      this.$router.push({
        name: 'products.edit',
        params: {
          id: this.productId,
        },
      });
    },
    /*
    * Closes the modal
    */
    closeModal() {
      this.toggle(false);
      this.unsetModalContent();
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/components/batchStartPopup/batchStartPopup.js